import React from 'react';
import { getDevelopersUrl } from '../utils/zerodhaBrokerErrors';

const ZerodhaBrokerErrorAlert = ({ message, err, className = '' }) => {
  const developersUrl = getDevelopersUrl(err);

  return (
    <div className={`p-4 bg-red-50 border border-red-200 rounded-lg text-red-800 text-sm ${className}`}>
      <p>{message}</p>
      <p className="mt-2">
        <a
          href={developersUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="font-medium text-blue-700 underline hover:text-blue-900"
        >
          Open Kite Connect developer console
        </a>
      </p>
    </div>
  );
};

export default ZerodhaBrokerErrorAlert;
